import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "~/components/ui/breadcrumb";
import useNextGenHeader from "~/contexts/nextgen-header";

export function ManifoldNextGenAppHeader() {
  const { breadcrumbs, title, actions } = useNextGenHeader();
  const navigate = useNavigate();

  return (
    <div className="grid shrink-0 grid-cols-[1fr_auto_1fr] items-center border-b border-border px-6 py-3">
      <div className="flex items-center">
        {breadcrumbs.length > 0 ? (
          <Breadcrumb>
            <BreadcrumbList>
              {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return (
                  <Fragment key={index}>
                    <BreadcrumbItem>
                      {isLast || !crumb.href ? (
                        <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink
                          href={crumb.href}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(crumb.href!);
                          }}
                        >
                          {crumb.label}
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast && <BreadcrumbSeparator />}
                  </Fragment>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        ) : (
          title && <span className="text-base font-medium text-foreground">{title}</span>
        )}
      </div>

      <div className="flex items-center justify-center px-4">
        {breadcrumbs.length > 0 && title && (
          <span className="text-sm font-medium text-foreground">{title}</span>
        )}
      </div>

      <div className="flex items-center justify-end gap-2">
        {actions[0]}
        {actions[1]}
      </div>
    </div>
  );
}
